// @TODO also used in data import service, move to package?

const functions = {
  datetime({ days, hours, format = 'iso-8601'}) {
    if (format !== 'iso-8601') {
      throw new Error('Invalid format ' + format + ' - only iso-8601 is supported');
    }

    const date = new Date();

    if (days !== undefined) {
      if (isNaN(days)) {
        throw new Error('days is not a number');
      }
      date.setDate(date.getDate() + parseInt(days));
    }

    if (hours !== undefined) {
      if (isNaN(hours)) {
        throw new Error('hours is not a number');
      }
      date.setHours(date.getHours() + parseInt(hours));
    }

    return date.toISOString();
  },
};

function advancedString(str, variables) {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/\$\{(.*?)\}/g, function (match, capture) {
    if (! capture.includes('(')) {
      if (! (capture in variables)) {
        throw new Error('Variable "' + capture + '" was not defined in advancedString');
      }
      return variables[capture];
    }
    let [functionName, paramStr] = capture.split('(');
    const params = {};
    paramStr.slice(0, paramStr.length - 1)
      .split(',')
      .forEach(str => {
        const split = str.split('=');
        params[split[0].trim()] = split[1].trim();
      });

    if (!(functionName in functions)) {
      throw new Error('Invalid function ' + functionName);
    }

    return functions[functionName](params);
  });
}

module.exports = advancedString;
